export type MascotStateId =
  | 'unknown'
  | 'clean'
  | 'moderate_approach'
  | 'moderate_cloth'
  | 'unhealthy'
  | 'very_unhealthy'
  | 'hazardous';

export const MASCOT_ART: Record<MascotStateId, { sheet: string; alt: string }> = {
  unknown: {
    sheet: '',
    alt: 'Waiting for an official air-quality reading. No air-quality status is inferred.',
  },
  clean: {
    sheet: '/images/animations/merlion-clean-5frames.webp',
    alt: 'The cheerful Merlion waves with no mask in the clean-air state.',
  },
  moderate_approach: {
    sheet: '/images/animations/merlion-moderate-approach-5frames.webp',
    alt: 'The Merlion holds a cloth mask and is about to put it on.',
  },
  moderate_cloth: {
    sheet: '/images/animations/merlion-moderate-cloth-5frames.webp',
    alt: 'The Merlion wears a cloth face mask and adjusts its ear loop.',
  },
  unhealthy: {
    sheet: '/images/animations/merlion-unhealthy-5frames.webp',
    alt: 'The worried Merlion crouches in a fitted N95 respirator.',
  },
  very_unhealthy: {
    sheet: '/images/animations/merlion-very-unhealthy-5frames.webp',
    alt: 'The tense Merlion wears a twin-filter respirator, with slightly red eyes.',
  },
  hazardous: {
    sheet: '/images/animations/merlion-hazardous-5frames.webp',
    alt: 'The frightened Merlion wears a full-face gas mask with watery red eyes behind its lenses.',
  },
};

export function getMascotStateForPsi(psi: number | null): MascotStateId {
  if (psi === null || !Number.isFinite(psi)) return 'unknown';
  const value = psi !== null && Number.isFinite(psi) ? Math.max(0, Math.round(psi)) : 0;
  if (value <= 50) return 'clean';
  if (value <= 75) return 'moderate_approach';
  if (value <= 100) return 'moderate_cloth';
  if (value <= 200) return 'unhealthy';
  if (value <= 300) return 'very_unhealthy';
  return 'hazardous';
}

export function mascotStill(state: MascotStateId): string {
  return MASCOT_ART[state].sheet.replace('-5frames.webp', '-still.webp');
}

export function mascotSheet(state: MascotStateId, small: boolean): string {
  return small ? MASCOT_ART[state].sheet.replace('.webp', '-small.webp') : MASCOT_ART[state].sheet;
}
